import {createRouter, createWebHistory} from 'vue-router'
import HomeView from '../views/HomeView.vue'

const router = createRouter({
  scrollBehavior: (to, from, savedPosition) => {
    if (savedPosition) {
      return savedPosition
    } else {
      return {top: 0}
    }
  },
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: HomeView
    },
    {
      path: '/vorankuendigung',
      name: 'vorankuendigung',
      component: () => import('../views/VorankuendigungView.vue'),
    },
    {
      path: '/bfsg',
      name: 'bfsg',
      component: () => import('../views/BfsgView.vue'),
    },
    {
      path: '/finanzuebersicht',
      name: 'finanzuebersicht',
      component: () => import('../views/FinancialStatusView.vue'),
    },
    {
      path: '/anweisung',
      name: 'anweisung',
      component: () => import('../views/PaymentOrderView.vue'),
    },
    {
      path: '/hhp',
      name: 'hhp',
      component: () => import('../views/BudgetView.vue'),
    },
    {
      path: '/afsg-verteilung',
      name: 'afsg-verteilung',
      component: () => import('../views/AfsgAllocationView.vue'),
    },
    {
      path: '/sitzungsprotokolle',
      name: 'sitzungsprotokolle',
      component: () => import('../views/ProceedingsView.vue'),
    },
    {
      path: '/wahltermine',
      name: 'wahltermine',
      component: () => import('../views/ElectionDates.vue'),
    },
    {
      path: '/wahltermine/:electionId',
      name: 'single-election',
      component: () => import('../views/SingleElection.vue'),
    },
    {
      path: '/sglieds',
      name: 'sglieds',
      component: () => import('../views/SGliedSView.vue'),
    },
    {
      path: '/diff/:dateStart/:dateEnd?',
      name: 'diff',
      component: () => import('../views/DiffView.vue'),
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('../views/LoginView.vue'),
    },
    {
      path: '/accounts',
      name: 'accounts',
      component: () => import('../views/AccountsView.vue'),
    },
    {
      path: '/accounts/create',
      name: 'accounts-create',
      component: () => import('../views/CreateAccountView.vue'),
    },
    {
      path: '/accounts/edit-permissions',
      name: 'accounts-edit-permissions',
      component: () => import('../views/EditPermissionsView.vue'),
    },
    {
      path: '/accounts/reset-password',
      name: 'accounts-reset-password',
      component: () => import('../views/ResetPasswordView.vue'),
    },
    {
      path: '/change-password',
      name: 'change-password',
      component: () => import('../views/ChangePasswordView.vue'),
    },
    {
      path: '/email-templates',
      name: 'email-templates',
      component: () => import('../views/EmailTemplatesView.vue'),
    },
    {
      path: '/email-queues',
      name: 'email-queues',
      component: () => import('../views/EmailQueuesView.vue'),
    },
    {
      path: '/logout',
      name: 'logout',
      component: () => import('../views/LogoutView.vue'),
    },
    {
      path: '/help',
      name: 'help',
      component: () => import('../views/HelpView.vue'),
    },
    {
      path: '/delete-request/:requestId',
      name: 'delete-request',
      component: () => import('../views/RequestDeleteView.vue'),
    },
    {
      path: '/payout-request/:requestId',
      name: 'payout-request',
      component: () => import('../views/SinglePayoutRequestView.vue'),
    },
    {
      path: '/document/:filename',
      name: 'single-document',
      component: () => import('../views/SingleDocumentView.vue'),
    },
  ]
})

export default router
